import { useId } from "react"

export function Switch({
    isCheck,
    toggleIsCheck,
    children,
    isDisabled = false,
    style = 1
}) {

    const id = useId();

    return (
        <div className='switch'>
            <input
                disabled={isDisabled}
                type="checkbox"
                id={id}
                checked={isCheck}
                onChange={() => toggleIsCheck()}
            />
            <label htmlFor={id} >
                {children}
            </label>
        </div>
    )

}